import { VirtualMeetingTypeEnum } from 'graphql/types';

export const virtualMeetingTypeOptions = [
  { label: 'Zoom Meeting', value: VirtualMeetingTypeEnum.AutoCreateZoom },
  { label: 'Google Meeting', value: VirtualMeetingTypeEnum.AutoCreateGoogleMeet },
  { label: 'User Defined', value: VirtualMeetingTypeEnum.OwnLink },
];

export const isVirtualEventType = (eventType?: string) => eventType === 'virtual' || eventType === 'both';

export const isGoogleMeetSetup = (eventType?: string, setup?: VirtualMeetingTypeEnum) =>
  isVirtualEventType(eventType) && setup === VirtualMeetingTypeEnum.AutoCreateGoogleMeet;
